import React, { useState, useEffect, useRef } from 'react';
import { Search } from 'lucide-react';
import CreateUserModal from '../../../components/CreateUserModal';
import { CreateUserProvider } from '../../../components/Providers/CreateUserProvider/CreateUserContext';
import SuccessModal from '../../../components/ConfirmModal/SuccessModal';

interface TableHeaderProps {
  onSearch?: (value: string) => void;
  onFilterClick?: () => void;
  onViewChange?: (view: 'list' | 'grid') => void;
  selectedView?: string;
}

const TemporaryInstructionHeader: React.FC<TableHeaderProps> = ({ onSearch, onFilterClick, onViewChange, selectedView = 'list' }) => {
  const [openCreateUser, setOpenCreateUser] = useState(false);
  const [successModal, setSuccessModal] = useState(false);
  const [searchQuery, setSearchQuery] = useState('');
  const debounceRef = useRef<ReturnType<typeof setTimeout> | null>(null);

  useEffect(() => {
    if (debounceRef.current) clearTimeout(debounceRef.current);

    debounceRef.current = setTimeout(() => {
      onSearch?.(searchQuery);
    }, 500);

    return () => {
      if (debounceRef.current) clearTimeout(debounceRef.current);
    };
  }, [searchQuery]);

  return (
    <div className="flex flex-col md:flex-row items-right md:items-center justify-between gap-3 p-4 bg-white rounded-md">
      {/* Controls */}
      <div className="flex flex-wrap items-center gap-2 w-full md:w-auto">
        {/* Search */}
        <div className="flex items-center border rounded-md px-2 py-1 w-full md:w-64">
          <Search size={16} className="text-gray-400 mr-1" />
          <input
            type="text"
            placeholder="Search"
            value={searchQuery}
            onChange={(e) => setSearchQuery(e.target.value)}
            className="w-full outline-none text-sm"
          />
        </div>

        {/* Filter button */}
        {/*<button onClick={onFilterClick} className="flex items-center gap-1 px-3 py-1 bg-gray-100 rounded-md hover:bg-gray-200 text-sm">
          <Filter size={16} /> Filter
        </button>*/}

        {/* Dropdown */}
        {/*<select className="border rounded-md px-2 py-1 text-sm">
          <option>Option 1</option>
          <option>Option 2</option>
        </select>

        {/* View toggle */}
        <div className="flex items-center border rounded-md overflow-hidden">
          {selectedView !== 'Users' && (
            <>
              {/*<button
                onClick={() => onViewChange && onViewChange('list')}
                className={`p-2 ${selectedView === 'list' ? 'bg-gray-200' : ''}`}
              >
                <List size={16} />
              </button>*/}
              {/*<button
                onClick={() => onViewChange && onViewChange('grid')}
                className={`p-2 ${selectedView === 'grid' ? 'bg-gray-200' : ''}`}
              >
                <Grid size={16} />
              </button>*/}
            </>
          )}

          {/* {selectedView === 'Users' && (
            <button
              className="flex items-center gap-2 bg-[#e84545] text-white px-4 py-2 rounded-md text-sm font-medium hover:opacity-90"
              onClick={() => setOpenCreateUser(true)}
            >
              <Plus size={16} /> New User
            </button>
          )} */}
        </div>
      </div>

      <CreateUserProvider>
        <CreateUserModal
          isOpen={openCreateUser}
          onClose={() => setOpenCreateUser(false)}
          onUserCreated={() => {
            setSuccessModal(true);
            setOpenCreateUser(false);
          }}
        />
      </CreateUserProvider>

      <SuccessModal
        isOpen={successModal}
        onClose={() => setSuccessModal(false)}
        title="User Created"
        message="The user has been successfully added."
        buttonText="OK"
        onButtonClick={() => setSuccessModal(false)}
      />
    </div>
  );
};

export default TemporaryInstructionHeader;
